import * as XLSX from 'xlsx';

// Выгрузка таблицы «Остатки» корпа: то, что на экране (с учётом фильтров), плюс строки буфера и менеджеров.
export default function exportWalletBalances({ items, company, period }) {
  const header = ['Тест', 'Строка', 'Остаток', 'Получено за период', 'Израсходовано за период'];
  const rows = [];
  items.forEach((item) => {
    rows.push([item.name, 'Всего по тесту', item.total.balance, item.total.received, item.total.spent]);
    rows.push([item.name, 'Буфер компании', item.buffer.balance, item.buffer.received, item.buffer.spent]);
    item.managers.forEach((m) => rows.push([item.name, m.name, m.balance, m.received, m.spent]));
  });

  const periodText = period.from || period.to ? `Период движений: ${period.from || '…'} — ${period.to || '…'}` : 'Период движений: всё время';
  const ws = XLSX.utils.aoa_to_sheet([[company || 'Корп. клиент'], [periodText], [], header, ...rows]);
  ws['!cols'] = [{ wch: 32 }, { wch: 28 }, { wch: 12 }, { wch: 20 }, { wch: 24 }];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Остатки');
  XLSX.writeFile(wb, `Остатки${company ? ` — ${company}` : ''}.xlsx`.replace(/[\\/:*?"<>|]/g, ''));
}
